import axios from 'axios'
import router from '@/router'
import { Message, Notification, Loading } from 'element-ui'
let appjs = (function () {
  function showMsg (type, msg, duration, offset) {
    if (!msg) {
      msg = '提示信息'
    }
    let config = {
      message: msg,
      duration: 2000,
      type: type
    }
    if (duration && !isNaN(duration)) {
      config.duration = duration
    }
    if (offset) {
      config.offset = offset
    }
    Message(config)
  }
  function showNotify (type, msg, title, duration, offset) {
    if (!msg) {
      msg = '提示信息'
    }
    let config = {
      title: title,
      message: msg,
      duration: 2000,
      type: type
    }
    if (duration && !isNaN(duration)) {
      config.duration = duration
    }
    if (offset) {
      config.offset = offset
    }
    Notification(config)
  }
  return {
    showWarningMsg (msg, duration, offset) {
      showMsg('warning', msg, duration, offset)
    },
    showSuccessMsg (msg, duration, offset) {
      showMsg('success', msg, duration, offset)
    },
    showInfoMsg (msg, duration, offset) {
      showMsg('info', msg, duration, offset)
    },
    showErrorMsg (msg, duration, offset) {
      showMsg('error', msg, duration, offset)
    },
    showWarningNotify (msg, title, duration, offset) {
      if (!title) {
        title = '警告'
      }
      showNotify('warning', msg, title, duration, offset)
    },
    showSuccessNotify (msg, title, duration, offset) {
      if (!title) {
        title = '成功'
      }
      showNotify('success', msg, title, duration, offset)
    },
    showInfoNotify (msg, title, duration, offset) {
      if (!title) {
        title = '消息'
      }
      showNotify('info', msg, title, duration, offset)
    },
    showErrorNotify (msg, title, duration, offset) {
      if (!title) {
        title = '错误'
      }
      showNotify('warning', msg, title, duration, offset)
    },
    loading (msg) {
      if (!msg) {
        msg = '数据加载中...'
      }
      let config = {
        lock: true,
        text: msg,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      }
      return Loading.service(config)
    },
    unloading (loadel) {
      loadel.close()
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        }
      )
    },
    HTMLDecode: function (text) {
      if (text) {
        let temp = document.createElement('div')
        temp.innerHTML = text
        let output = temp.innerText || temp.textContent
        temp = null
        return output
      } else {
        return ''
      }
    },
    httpRequest (url, params, method, fun) {
      var methodtype = 'POST'
      if (method == 'post' || method == 'get') {
        methodtype = method
      }
      let config = {
        url: url,
        method: methodtype
      }
      const instance = axios.create({
        baseURL: '/api',
        timeout: 30000
      })
      // 2、axios 的拦截
      // 2、1 请求拦截
      instance.interceptors.request.use(
        config => {
          let authorization = localStorage.getItem('authorization')
            ? localStorage.getItem('authorization')
            : ''
          // 发送请求时携带token
          if (authorization) {
            config.headers.Authorization = authorization
          } else {
            router.push('/login')
          }
          if (params) {
            if (method == 'multiple' || method == 'fileupload') {
              //文件上传
              config.data = params
              config.onUploadProgress = event => {
                fun(event)
              }
            } else if (method == 'post') {
              config.data = params // POST 请求使用 data
            } else {
              config.params = params // GET 请求使用 params
            }
          }
          return config
        },
        err => {
          console.log(err)
        }
      )
      // 2、2响应拦截器
      instance.interceptors.response.use(
        res => {
          if (res && res.data && res.data.retCode == 40010) {
            router.push('/login')
            this.showErrorMsg('未经授权或授权已过期，请重新登录！')
          }
          return res.data
        },
        err => {
          this.showErrorMsg('服务器异常：' + err)
        }
      )
      //3、发送真正的网络请求
      return instance(config) //返回一个Promise
    },
    requestWithNoToten (url, params, method) {
      if (!method) {
        method = 'POST'
      }
      return new Promise((resolve, reject) => {
        axios({
          method: method,
          url: url,
          params: params,
          baseURL: '/api',
          withCredentials: false
        })
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formatDateOnly (value) {
      if (value === undefined || value === null || value === '') {
        return ''
      }
      const str = String(value).trim()
      const matched = str.match(/^(\d{4}-\d{2}-\d{2})/)
      if (matched && matched[1]) {
        return matched[1]
      }
      return str
    },
    tableDateFormatter (row, column, cellValue) {
      return this.formatDateOnly(cellValue)
    }
  }
})()
export { appjs }
